import React from 'react';


interface CategoryFilterProps {
  categories: Array<{ id: string; label: string; count: number }>;
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  activeCategory,
  onCategoryChange,
}) => {
  return (
    <div className="flex flex-wrap gap-3">
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          className={`flex items-center space-x-2 px-4 py-2 rounded-full font-body text-sm font-medium transition-all duration-300 ${
            activeCategory === category.id
              ? 'bg-primary text-primary-foreground shadow-md'
              : 'bg-muted text-foreground hover:bg-primary hover:text-primary-foreground'
          }`}
        >
          <span>{category.label}</span>
          <span
            className={`px-2 py-0.5 rounded-full text-xs font-bold ${
              activeCategory === category.id
                ? 'bg-primary-foreground text-primary'
                : 'bg-background text-muted-foreground'
            }`}
          >
            {category.count}
          </span>
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;